import ButtonOutlined from '@components/buttos/button-outlined';
import ModalComponet from '@components/modal';
import { BasicCall, CallRecive } from '@customHooks/voice-call/use-voice-call';
// import { Box, Snackbar } from '@material-ui/core';

interface CallAlertProps {
    open: boolean,
    reciveCall: () => void
    declineCall: () => void
    callInProsess: boolean
    call: CallRecive | undefined
    leaveUser?: BasicCall
}

const CallAlert = ({open, reciveCall, declineCall, callInProsess, call, leaveUser}: CallAlertProps) => {
    return (
        <ModalComponet
            open={open}
            onClose={() => null}
        >
                    <div className="Callcard">
                        <div className="Callcard__TitleContainer">
                            <p className="Callcard__Title">
                                {leaveUser ? 'Llamada terminada' : !callInProsess ? 'Llamada de voz entrante' : <span className="Callcard__Title-Green">Llamada en proceso</span>}
                            </p>
                            <p className="Callcard__Text">
                                Paciente: <strong>{call?.nameEmit}</strong> {leaveUser ? 'Ha abandonado la llamada' : ''}
                            </p>
                        </div>
                        <div className="Callcard__ButtonsContainer">
                            {!callInProsess && !leaveUser  ?
                                <ButtonOutlined
                                    label={'No disponible'}
                                    icon={'fas fa-phone-hangup'}
                                    action={() => declineCall()}
                                />
                            : null}
                            {!callInProsess && !leaveUser  ?
                                <ButtonOutlined
                                    label={'Contestar llamada'}
                                    icon={'fa fa-phone'}
                                    style={{backgroundColor: '#58CF09'}}
                                    action={() => reciveCall()}
                                />
                            :
                                <ButtonOutlined
                                    label={'Terminar llamada'}
                                    icon={'fa fa-phone-hangup'}
                                    action={() => declineCall()}
                                />
                            }
                        </div>
                    </div>
        </ModalComponet>
    );
}

export default CallAlert
